// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"313":"90eb9ced","616":"6b3cfbb1","787":"55f4128e"}[chunkId] + ".chunk.js";
};